import { getOrganization } from '@/store'

// Organization Feature Flags
export const ANNOUNCEMENTS = 'announcements_enabled'
export const AUDIO_MESSAGES = 'audio_messages_enabled'
export const IMPORTS = 'imports_enabled'
export const INTEGRATIONS = 'integrations_enabled'
export const MEETINGS_CAPTIONS = 'meetings_captions_enabled'
export const MEETINGS = 'meetings_enabled'
export const SEARCH = 'search_enabled'
export const SUPERGROUPS = 'supergroups_enabled'
export const TASKS = 'tasks_enabled'
export const USER_PRONOUNS = 'user_pronouns_enabled'
export const USER_TITLE = 'user_title_enabled'
export const POLLS = 'polls_enabled'

export const orgFlags = {
	ANNOUNCEMENTS,
	AUDIO_MESSAGES,
	IMPORTS,
	INTEGRATIONS,
	MEETINGS_CAPTIONS,
	MEETINGS,
	SEARCH,
	SUPERGROUPS,
	TASKS,
	USER_PRONOUNS,
	USER_TITLE,
	POLLS,
}

const allFlags = Object.values(orgFlags)

export const orgFlag = (flag) => {
	if (!flag || !allFlags.includes(flag)) {
		console.error(
			`Flags: tried to check for unknown organization feature flag: "${flag}"`
		)
		return false
	}
	const org = getOrganization() || {}
	return org[flag] !== undefined ? org[flag] : false
}
